import {
	faRightLeft as fasRightLeft,
	faWifi as fasWifi,
	faHouse as fasHouse,
	faPlus as fasPlus,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import React from "react";

export interface HtmlBlockProps {
	as?: "p" | "div" | "li" | "span" | "td";
	id?: string;
	className?: string;
	html: string;
}
interface Rule {
	pattern: RegExp;
	replaceValue: string;
}
const RULES: Rule[] = [
	{
		pattern: /(<\/?br[ \r\t]*\/?>|\n)+/gim,
		replaceValue: "<br>",
	},
	{
		pattern: /<br><li+/gim,
		replaceValue: "<li",
	},
	{
		pattern: /<br><\/ul>+/gim,
		replaceValue: "</ul>",
	},
];

const htmlCleaner = (html: string): string => {
	let lastResult = (html || "").replace(/style="[^"]*"/g, "").replace(/><\/i>/gim, ">&nbsp;</i>");
	let result;

	do {
		result = lastResult;
		lastResult = result.replace(/<[^/>]+>[ \n\r\t]*<\/[^>]+>/gim, "");
	} while (result !== lastResult);

	RULES.forEach(({ pattern: patern, replaceValue }) => {
		lastResult = lastResult.replace(patern, replaceValue);
	});

	lastResult = lastResult.replace("tick-list tick-list-green", "list-style-tick list-success list-sm");

	if (lastResult.includes("list-style-tick") && !lastResult.includes("fas fa-check")) {
		lastResult = lastResult.replace(
			/<li>/g,
			'<li><svg xmlns="http://www.w3.org/2000/svg" class="svg-inline--fa fa-check mr-2 text-success" aria-hidden="true" viewBox="0 0 448 512"><path fill="currentColor" d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"/></svg>',
		);
	}

	// Ikoncserék ahol kell
	const icons = [fasRightLeft, fasWifi, fasHouse, fasPlus];
	icons.forEach((icon) => {
		lastResult = lastResult.replace(
			RegExp(
				`<i class="${icon.prefix}? fa-(${[icon.iconName, ...icon.icon[2]]
					.filter(Boolean)
					.join("|")})(\\s+[^"]*)?"[^>]*>[^<]*<\\/i>`,
				"g",
			),
			`<svg xmlns="http://www.w3.org/2000/svg" class="svg-inline--fa fa-${icon.iconName}" aria-hidden="true" viewBox="0 0 ${icon.icon[0]} ${icon.icon[1]}"><path fill="currentColor" d="${icon.icon[4]}"/></svg>`,
		);
	});

	return lastResult;
};

export const HtmlBlock = React.forwardRef<HTMLElement, HtmlBlockProps>(
	({ as: Component = "div", html, ...props }, _ref) => (
		<Component {...props} dangerouslySetInnerHTML={{ __html: htmlCleaner(html) }} />
	),
);
